export const formatPrix = (prix: number) => {
  return prix.toLocaleString("fr-FR", { style: "currency", currency: "EUR" });
};
